import { api } from "../Configurations/axios";

const GetGrants = async (companyId: string, SearchText: string, page: number) => {
    try {
        const result = await api.get(`/financinglines/GetFinancingLinesPaginated?companyId=${companyId}&page=${page}&take=8&word=${SearchText === '' || SearchText === undefined ? 'all' : SearchText}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    } 
}

const GetGrantByIdAPI = async (id: string, typeOf: number) => {
    try {
        if (typeOf === 1) {
            const { data } = await api.get(`/Refundables/GetRefundable?financingId=${id}`);
            return data
        } else {
            const { data } = await api.get(`/Subventions/GetSubvention?financingId=${id}`);
            return data
        }
    } catch (err) {
        console.log(err)
    }
}

const GetGrantsFavorite = async (id: string) => {
    try {
        const result = await api.get(`/GrantsLine/GetFavoriteGrants?CompanyId=${id}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const UpdateGrantsFavAPI = async (favoritesGrantsId: string, companyId: string, favoritesGrantsName: string, 
    userEmail: string, favoritesGrantOrganism: string, favoritesGrantDescription: string) => {
    try {
        const result = await api.post('/GrantsLine/UpdateGrant', {
            favoritesGrantsId,
            favoritesGrantsName,  
            companyId,
            userEmail,
            favoritesGrantOrganism,
            favoritesGrantDescription
        });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const  GetAllGroupedByOrganismAPI = async(companyId: string, panelId: string) =>{
    try{
        const result = await api.get(`/GrantsLine/GetAllGroupedByOrganism/?companyId=${companyId}&panelId=${panelId}`);
        const response = result.data;
        return response;
    }catch(error: any) {
        throw new Error(error.response.data);
    }
}
const  GetAllProjectGroupingByOrganismAPI = async(companyId: string, panelId: string) =>{
    try{
        const result = await api.get(`/GrantsLine/GetAllProjectGroupingByOrganism/?companyId=${companyId}&panelId=${panelId}`);
        const response = result.data;
        return response;
    }catch(error: any) {
        throw new Error(error.response.data);
    }
}
export {
    GetGrants,
    GetGrantByIdAPI,
    UpdateGrantsFavAPI,
    GetAllGroupedByOrganismAPI,
    GetAllProjectGroupingByOrganismAPI,
    GetGrantsFavorite
}